import { render, staticRenderFns } from "./Fleets.vue?vue&type=template&id=1a3553da&scoped=true"
import script from "./Fleets.vue?vue&type=script&lang=js"
export * from "./Fleets.vue?vue&type=script&lang=js"
import style0 from "./Fleets.vue?vue&type=style&index=0&id=1a3553da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3553da",
  null
  
)

export default component.exports